import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/Brands.css";

import b1 from "../assets/images/Brand/b1.jpg";
import b2 from "../assets/images/Brand/b2.jpg";
import b3 from "../assets/images/Brand/b3.jpg";
import b4 from "../assets/images/Brand/b4.jpg";
import b5 from "../assets/images/Brand/b5.jpg";
import b6 from "../assets/images/Brand/b6.jpg";
import b7 from "../assets/images/Brand/b7.jpg";
import b8 from "../assets/images/Brand/b8.jpg";
import b9 from "../assets/images/Brand/b9.jpg";
import b10 from "../assets/images/Brand/b10.jpg";
import b11 from "../assets/images/Brand/b11.jpg";
import b12 from "../assets/images/Brand/b12.jpg";
import b13 from "../assets/images/Brand/b13.jpg";
import b14 from "../assets/images/Brand/b14.jpg";
import b15 from "../assets/images/Brand/b15.jpg";
import b16 from "../assets/images/Brand/b16.jpg";
import b17 from "../assets/images/Brand/b17.jpg";
import b18 from "../assets/images/Brand/b18.jpg";
import b19 from "../assets/images/Brand/b19.jpg";
import b20 from "../assets/images/Brand/b20.jpg";
import b21 from "../assets/images/Brand/b21.jpg";
import b22 from "../assets/images/Brand/b22.jpg";
import b23 from "../assets/images/Brand/b23.jpg";
import b24 from "../assets/images/Brand/b24.jpg";
import b25 from "../assets/images/Brand/b25.jpg";
import b26 from "../assets/images/Brand/b26.jpg";
import b27 from "../assets/images/Brand/b27.jpg";
import b28 from "../assets/images/Brand/b28.jpg";
import b29 from "../assets/images/Brand/b29.jpg";
import b30 from "../assets/images/Brand/b30.jpg";
import b31 from "../assets/images/Brand/b31.jpg";
import b32 from "../assets/images/Brand/b32.jpg";


// ✅ images array me sab add karein
const images = [
  b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16,
  b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32

];

function Brands() {
  return (
    <>
      <Navbar />

      <section className="brands-section">
        <div className="brands-header">
          <h1>Our Top Brands</h1>
          <p>
            These are the top brands we collaborate with, We take pride in partnering with trusted and reputable names. Our partnerships ensure quality, reliability, and seamless operations. Together, we connect markets and deliver excellence worldwide.
          </p>
        </div>

        <div className="brands-grid">
          {images.map((img, index) => (
            <div key={index} className="brand-card">
              <img src={img} alt={`Brand ${index + 1}`} />
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Brands;
